import React from "react";
import Image from 'next/image';
import cssStyles from "./cms_renderer.module.scss";
import { parseDimension, extractStylesFromUrl } from "./shared";
import { SectionData, ComponentRenderProps} from "./index";
import { trackItem } from "@/utils";

interface CustImageProps {
    sectionData: SectionData;
    props: ComponentRenderProps;
    index?: number;
}

const CustImage = ({ sectionData, props, index = 1 }: CustImageProps): JSX.Element => {
    const { stylesFromUrl, urlStr, quality, preload, unoptimized } = extractStylesFromUrl(sectionData.imageUrl as string);
    const imageStylesFromUiComp = sectionData.uiCompType?.styles || {};

    const imageStyles = { ...imageStylesFromUiComp, ...stylesFromUrl, quality: 75};
    const imageContainerStyles = { ...sectionData.uiCompType?.containerStyles, ...sectionData.uiCompType?.parentStyles };
    const objectFit = imageStyles.objectFit as string || "cover";
    let isPreload = sectionData.uiCompType?.options?.preload || preload || false;

    if (!imageContainerStyles.height && !imageContainerStyles.width) {
        if (imageStyles.width) {
            imageContainerStyles.width = `${parseDimension(imageStyles.width as string | number)}px`;
            delete imageStyles.width;
        }

        if (imageStyles.height) {
            imageContainerStyles.height = `${parseDimension(imageStyles.height as string | number)}px`;
            delete imageStyles.height;
            if (!imageContainerStyles.width) {
                imageContainerStyles.width = '100%';
            }
        }
    }

    const handleImageOnLoad = (event: React.SyntheticEvent<HTMLImageElement>) => {
        if (window.innerWidth <= 768) {
            const imageElement = event.currentTarget as HTMLElement;
            imageElement.style.height = '';
            const parentElement = imageElement.parentElement;
            if (parentElement) {
                parentElement.style.height = `${imageElement.offsetHeight}px`;
            }
        }
    };

    const image = (
        (imageStyles.width && imageStyles.height) ? (
            <Image
                alt={sectionData.title || sectionData.imageUrl || ''}
                src={urlStr as string}
                width={parseDimension(imageStyles.width as string)}
                height={parseDimension(imageStyles.height as string)}
                style={imageStyles}
                className={cssStyles.image}
                onLoad={handleImageOnLoad}
                quality={quality as number}
                priority={isPreload}
                loading={isPreload ? "eager" : "lazy"}
                unoptimized= {unoptimized as boolean}
            />
        ) : (
            <Image
                alt={sectionData.title || urlStr || ''}
                src={urlStr as string}
                fill={true}
                layout="fill"
                objectFit={objectFit as "cover" | "contain" | "fill" | "none" | "scale-down"}
                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                quality={quality as number}
                style={imageStyles}
                onError={(e) => console.error("Failed to load Image : " + urlStr)}
                className={cssStyles.image}
                onLoad={handleImageOnLoad}
                priority={isPreload}
                loading={isPreload ? "eager" : "lazy"}
                unoptimized={unoptimized as boolean}
            />
        )
    );

    return (
        <>
            {sectionData.link ? (
                <a id={ sectionData.trackId || 'image_' }  href={sectionData.link} target={sectionData.newTab ? "_blank" : "_self"}
                    onClick={(e) => {
                        trackItem(sectionData.trackInfo || { event: 'custImageLinkClick', section: sectionData.trackId });
                    }}
                >
                    <div key={sectionData.trackId as string + index} className={cssStyles.imageContainer} style={{ position: 'relative', ...imageContainerStyles }}>
                        {image}
                    </div>
                </a>
            ) : (
                <div key={String(sectionData.trackId || index)} className={cssStyles.imageContainer} style={{ position: 'relative', ...imageContainerStyles }}>
                    {image}
                </div>
            )}
        </>
    );
}
export default CustImage;
